module.exports = __webpack_public_path__ + "static/media/mmz2.97f049b3.png";